import api from '@/api/index'
const state = {
  allNumber: 0,
  crfcode: '', // csrf token
  collection: '' // 公钥
}

const getters = {
  allNumber: state => state.allNumber,
  crfcode: state => state.crfcode,
  collection: state => state.collection
}

const actions = {
  getAllNum: ({ commit }, data) => commit('getAllNum', data),
}

const mutations = {
  getAllNum (state, inner) {
    console.log(inner);
  },
  getCrf (state, inner) {
    state.crfcode = ''
    state.crfcode = inner
    console.log(inner)
  },
  getPasWord (state, inner) {
    return inner
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}
